const Avatar = {
  baseStyle: {
    borderStyle: "solid",
    position: "relative",
    borderRadius: "100%",
    display: "block",
    borderWidth: ".5px",
    borderColor: "grayscale.200",
    '&[data-state="hidden"]': {
      display: "none"
    },
    _dark: {
      borderColor: "grayscale.700"
    }
  },
  // Iris sizes
  sizes: {
    xs: { height: "1.5rem", width: "1.5rem" },
    sm: { height: "2rem", width: "2rem" },
    md: { height: "2.5rem", width: "2.5rem" },
    lg: { height: "3rem", width: "3rem" },
    xl: { height: "3.5rem", width: "3.5rem" },
    "2xl": { height: "6rem", width: "6rem" },
    "3xl": { height: "8rem", width: "8rem" },
    auto: { height: "100%", width: "100%" }
  }
};

export { Avatar };
